import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverviewPage } from 'src/overview';
import { AccountsPage, AccountsForReviewPage } from 'src/account';
import { PeoplePage } from 'src/people';
import { BusinessPage } from 'src/business';
import { LocationsPage } from 'src/locations';
import { VendorsPage } from 'src/vendor';
import { ProductsPage } from 'src/product';
import { DocumentsPage } from 'src/document';
import { ConsentsPage } from 'src/consent';
import { ReportsPage } from 'src/transaction';
import { InsuranceSubmitPage, InsuranceLogsPage } from 'src/insurance';
import { ReviewAndSubmitPage } from 'src/review-and-submit';
import { FIPage, FIDashboardPage } from 'src/financial-institution';
import { AllVendorsPage } from 'src/all-vendor/views';
import { UsersPage } from 'src/user';
import { PaymentPage } from 'src/payment';
import { LoansPage } from 'src/loans';
import { ObligationsPage } from 'src/obligations';
import { ComplianceDashboardPage } from 'src/compliance';
import { MetrcPage } from 'src/metrc';
import { LicenseAdminPage } from 'src/license';
import { AuditsPage } from 'src/audits';
import {
  SuperAdminDashboardLayout,
  OverviewPage as DashboardOverviewPage,
  TransactionsPage as DashboardTransactionsPage,
  SettingsPage as DashboardSettingsPage,
  MerchantConfigPage as DashboardMerchantConfigPage,
  FIConfigPage as DashboardFIConfigPage,
  PayoutsPage as DashboardPayoutsPage,
} from 'src/solventpay/dashboard';

export const OVERVIEW_ROUTE = {
  label: 'Overview',
  icon: <FontAwesomeIcon icon={['fal', 'tachometer-slow']} size="lg" />,
  to: '/',
  exact: true,
  component: process.env.NODE_ENV === 'production' ? null : OverviewPage,
  showOnSidebar: true,
};
export const COMPLIANCE_ROUTE = {
  label: 'Compliance',
  icon: <FontAwesomeIcon icon={['fal', 'tachometer-slow']} size="lg" />,
  to: '/compliance',
  path: '/compliance/*',
  component: ComplianceDashboardPage,
  showOnSidebar: true,
};
export const METRC_ROUTE = {
  label: 'Metrc',
  icon: <FontAwesomeIcon icon={['fal', 'tachometer-slow']} size="lg" />,
  to: '/metrc',
  component: MetrcPage,
  showOnSidebar: true,
};

export const LICENSE_ROUTE = {
  label: 'License',
  icon: <FontAwesomeIcon icon={['fal', 'map-marked-alt']} size="lg" />,
  to: '/licenses',
  path: '/licenses/*',
  component: LicenseAdminPage,
  showOnSidebar: true,
};

export const AUDITS_ROUTE = {
  label: 'Audits',
  icon: <FontAwesomeIcon icon={['fal', 'clipboard-check']} size="lg" />,
  to: '/audits',
  path: '/audits/*',
  component: AuditsPage,
  showOnSidebar: (user) => user.financialInstitutionHasAudits,
};

export const ACCOUNTS_ROUTE = {
  label: 'Accounts',
  icon: <FontAwesomeIcon icon={['fal', 'user']} size="lg" />,
  to: '/accounts',
  path: '/accounts/*',
  component: AccountsPage,
  showOnSidebar: true,
};

export const ACCOUNTS_FOR_REVIEW_ROUTE = {
  label: 'Review Accounts',
  icon: <FontAwesomeIcon icon={['fal', 'users-cog']} size="lg" />,
  to: '/accounts-for-review',
  component: AccountsForReviewPage,
  showOnSidebar: true,
};

export const PEOPLE_ROUTE = {
  label: 'People',
  icon: <FontAwesomeIcon icon={['fal', 'user']} size="lg" />,
  to: '/people',
  path: '/people/*',
  component: PeoplePage,
  showOnSidebar: true,
};
export const INSURANCE_SUBMIT_ROUTE = {
  label: 'Insurance Submit',
  icon: <FontAwesomeIcon icon={['fal', 'file-check']} size="lg" />,
  to: '/insurance-submit',
  path: '/insurance-submit/*',
  component: InsuranceSubmitPage,
  showOnSidebar: true,
};

export const INSURANCE_LOGS_ROUTE = {
  label: 'Insurance Logs',
  icon: <FontAwesomeIcon icon={['fal', 'clipboard-list-check']} size="lg" />,
  to: '/insurance-logs',
  path: '/insurance-logs/*',
  component: InsuranceLogsPage,
  showOnSidebar: true,
};

export const BUSINESS_ROUTE = {
  label: 'Business',
  icon: <FontAwesomeIcon icon={['fal', 'store-alt']} size="lg" />,
  to: '/business',
  // path: '/business/*',
  component: BusinessPage,
  showOnSidebar: true,
};

export const LOCATIONS_ROUTE = {
  label: 'Locations',
  icon: <FontAwesomeIcon icon={['fal', 'map-marked-alt']} size="lg" />,
  to: '/locations',
  path: '/locations/*',
  component: LocationsPage,
  showOnSidebar: true,
};

export const VENDORS_ROUTE = {
  label: 'Vendors',
  icon: <FontAwesomeIcon icon={['fal', 'comments-dollar']} size="lg" />,
  to: '/vendors',
  path: '/vendors/*',
  component: VendorsPage,
  showOnSidebar: true,
};

export const PRODUCTS_ROUTE = {
  label: 'Products',
  icon: <FontAwesomeIcon icon={['fal', 'boxes']} size="lg" />,
  to: '/products',
  path: '/products/*',
  component: ProductsPage,
  showOnSidebar: true,
};

export const DOCUMENTS_ROUTE = {
  label: 'Documents',
  icon: <FontAwesomeIcon icon={['fal', 'file-alt']} size="lg" />,
  to: '/documents',
  path: '/documents/*',
  component: DocumentsPage,
  showOnSidebar: true,
};

export const CONSENTS_ROUTE = {
  label: 'Consents',
  icon: <FontAwesomeIcon icon={['far', 'signature']} size="lg" />,
  to: '/consents',
  // path: '/consents/*',
  component: ConsentsPage,
  showOnSidebar: true,
};

export const TRANSACTIONS_ROUTE = {
  label: 'Transactions',
  icon: <FontAwesomeIcon icon={['fal', 'receipt']} size="lg" />,
  to: '/reports',
  path: '/reports/*',
  component: ReportsPage,
  showOnSidebar: true,
};

export const REVIEW_ROUTE = {
  label: 'Review',
  icon: <FontAwesomeIcon icon={['fal', 'clipboard-list-check']} size="lg" />,
  to: '/review',
  path: '/review/*',
  component: ReviewAndSubmitPage,
  showOnSidebar: true,
};

export const FIS_ROUTE = {
  label: 'FIs',
  icon: <FontAwesomeIcon icon={['fal', 'piggy-bank']} size="lg" />,
  to: '/financial-institutions',
  path: '/financial-institutions/*',
  component: FIPage,
  showOnSidebar: true,
};

export const FI_DASHBOARD_ROUTE = {
  label: 'FI Dashboard',
  to: '/fis/:id/dashboard',
  path: '/fis/:id/dashboard',
  component: FIDashboardPage,
  showOnSidebar: false, // Hidden from sidebar, accessed via FIs page
};

export const ALL_VENDORS_ROUTE = {
  label: 'Vendors',
  to: '/all-vendors',
  path: '/all-vendors/*',
  icon: <FontAwesomeIcon icon={['fal', 'comments-dollar']} size="lg" />,
  showOnSidebar: true,
  component: AllVendorsPage,
};

export const USERS_ROUTE = {
  label: 'Users',
  to: '/users',
  path: '/users/*',
  showOnSidebar: false,
  component: UsersPage,
};

export const PAYMENTS_ROUTE = {
  label: 'Payment',
  icon: <FontAwesomeIcon icon={['fal', 'money-check-alt']} size="lg" />,
  to: '/payment',
  component: PaymentPage,
  showOnSidebar: true,
};
export const LOANS_ROUTE = {
  label: 'Loans',
  icon: <FontAwesomeIcon icon={['far', 'signature']} size="lg" />,
  to: '/loans',
  path: '/loans/*',
  component: LoansPage,
  showOnSidebar: true,
};
export const OBLIGATIONS_ROUTE = {
  label: 'Obligations',
  icon: <FontAwesomeIcon icon={['far', 'signature']} size="lg" />,
  to: '/obligations',
  path: '/obligations/*',
  component: ObligationsPage,
  showOnSidebar: true,
};

// SolventPay Dashboard sub-routes
const SOLVENTPAY_OVERVIEW_ROUTE = {
  label: 'Overview',
  icon: <FontAwesomeIcon icon={['fal', 'tachometer-slow']} size="lg" />,
  to: '/solventpay/overview',
  path: 'overview',
  component: DashboardOverviewPage,
};

const SOLVENTPAY_TRANSACTIONS_ROUTE = {
  label: 'Transactions',
  icon: <FontAwesomeIcon icon={['fal', 'receipt']} size="lg" />,
  to: '/solventpay/transactions',
  path: 'transactions',
  component: DashboardTransactionsPage,
};

const SOLVENTPAY_SETTINGS_ROUTE = {
  label: 'Settings',
  icon: <FontAwesomeIcon icon={['fal', 'cog']} size="lg" />,
  to: '/solventpay/settings',
  path: 'settings',
  component: DashboardSettingsPage,
};

const SOLVENTPAY_FI_CONFIG_ROUTE = {
  label: 'ISO Config',
  icon: <FontAwesomeIcon icon={['fal', 'store-alt']} size="lg" />,
  to: '/solventpay/fi-config',
  path: 'fi-config',
  component: DashboardFIConfigPage,
};

const SOLVENTPAY_MERCHANT_CONFIG_ROUTE = {
  label: 'Merchant Config',
  icon: <FontAwesomeIcon icon={['fal', 'user-tag']} size="lg" />,
  to: '/solventpay/merchant-config',
  path: 'merchant-config',
  component: DashboardMerchantConfigPage,
};

const SOLVENTPAY_PAYOUTS_ROUTE = {
  label: 'Payouts',
  icon: <FontAwesomeIcon icon={['fal', 'money-check-alt']} size="lg" />,
  to: '/solventpay/payouts',
  path: 'payouts',
  component: DashboardPayoutsPage,
};

export const SOLVENTPAY_DASHBOARD_ROUTE = {
  label: 'SolventPay',
  icon: <FontAwesomeIcon icon={['fal', 'chart-network']} size="lg" />,
  to: '/solventpay',
  path: '/solventpay/*',
  component: SuperAdminDashboardLayout,
  submenu: [
    SOLVENTPAY_OVERVIEW_ROUTE,
    SOLVENTPAY_TRANSACTIONS_ROUTE,
    SOLVENTPAY_FI_CONFIG_ROUTE,
    SOLVENTPAY_MERCHANT_CONFIG_ROUTE,
    SOLVENTPAY_PAYOUTS_ROUTE,
    SOLVENTPAY_SETTINGS_ROUTE,
  ],
  showOnSidebar: true,
};

// FI Admin version of SolventPay (only Overview + Transactions, no admin config)
export const SOLVENTPAY_FI_ADMIN_ROUTE = {
  label: 'SolventPay',
  icon: <FontAwesomeIcon icon={['fal', 'chart-network']} size="lg" />,
  to: '/solventpay',
  path: '/solventpay/*',
  component: SuperAdminDashboardLayout,
  submenu: [
    SOLVENTPAY_OVERVIEW_ROUTE,
    SOLVENTPAY_TRANSACTIONS_ROUTE,
  ],
  showOnSidebar: true,
};

// Merchant Admin version of SolventPay (Overview with terminals + their Transactions)
export const SOLVENTPAY_MERCHANT_ADMIN_ROUTE = {
  label: 'SolventPay',
  icon: <FontAwesomeIcon icon={['fal', 'chart-network']} size="lg" />,
  to: '/solventpay',
  path: '/solventpay/*',
  component: SuperAdminDashboardLayout,
  submenu: [
    SOLVENTPAY_OVERVIEW_ROUTE,
    SOLVENTPAY_TRANSACTIONS_ROUTE,
  ],
  showOnSidebar: true,
};

// Backwards compatibility alias
export const SUPER_ADMIN_DASHBOARD_ROUTE = SOLVENTPAY_DASHBOARD_ROUTE;
export const MERCHANT_ADMIN_ROUTES = account => ({
  label: 'Account',
  icon: <FontAwesomeIcon icon={['fal', 'user-tag']} size="lg" />,
  submenu: [
    account.hasBusinessPage && BUSINESS_ROUTE,
    account.hasLocationsPage && LOCATIONS_ROUTE,
    account.hasPeoplePage && PEOPLE_ROUTE,
    account.hasVendorsPage && VENDORS_ROUTE,
    account.hasProductsPage && PRODUCTS_ROUTE,
    account.hasDocumentsPage && DOCUMENTS_ROUTE,
    account.hasConsentsPage && CONSENTS_ROUTE,
    COMPLIANCE_ROUTE,
    account.hasPaymentsPage && PAYMENTS_ROUTE,
    account.hasLoansPage && LOANS_ROUTE,
    account.hasObligationsPage && OBLIGATIONS_ROUTE,
    REVIEW_ROUTE,
  ].filter(Boolean),
  showOnSidebar: true,
});

// Get merchant routes including SolventPay if POS is enabled
export const getMerchantAdminRoutes = account => {
  const routes = [MERCHANT_ADMIN_ROUTES(account)];
  if (account.enablePosPayments) {
    routes.unshift(SOLVENTPAY_MERCHANT_ADMIN_ROUTE);
  }
  return routes;
};

export const INSURANCE_ADMIN_ROUTES = [
  USERS_ROUTE,
  INSURANCE_SUBMIT_ROUTE,
  INSURANCE_LOGS_ROUTE,
];

export const BANK_ADMIN_ROUTES = [
  COMPLIANCE_ROUTE,
  AUDITS_ROUTE,
  USERS_ROUTE,
  ALL_VENDORS_ROUTE,
  // REPORTS_ROUTE,
];

export const BANK_EMPLOYEE_ROUTES = [OVERVIEW_ROUTE, ACCOUNTS_ROUTE];

export const SUPER_ADMIN_ROUTES = [
  SUPER_ADMIN_DASHBOARD_ROUTE,
  FIS_ROUTE,
  FI_DASHBOARD_ROUTE,
  ALL_VENDORS_ROUTE,
  ACCOUNTS_FOR_REVIEW_ROUTE,
  METRC_ROUTE,
  LICENSE_ROUTE,
];

export const BANK_READ_ONLY_ROUTES = [
  ACCOUNTS_ROUTE,
  // READ_ONLY_DROPDOWN
];

export const MERCHANT_EMPLOYEE_ROUTES = [PEOPLE_ROUTE];
export const INSURANCE_USER_ROUTES = [PEOPLE_ROUTE];
// export const INSURANCE_AGENT_ROUTES = [PEOPLE_ROUTE]

export const INSURANCE_AGENT_ROUTES = () => ({
  label: 'Account',
  icon: <FontAwesomeIcon icon={['fal', 'user-tag']} size="lg" />,
  submenu: [PEOPLE_ROUTE, BUSINESS_ROUTE].filter(Boolean),
  showOnSidebar: true,
});
export const EDITABLE_MERCHANT_ROUTES = account =>
  [
    account.hasBusinessPage && BUSINESS_ROUTE,
    account.hasLocationsPage && LOCATIONS_ROUTE,
    account.hasPeoplePage && PEOPLE_ROUTE,
    account.hasVendorsPage && VENDORS_ROUTE,
    account.hasProductsPage && PRODUCTS_ROUTE,
    account.hasDocumentsPage && DOCUMENTS_ROUTE,
    account.hasConsentsPage && CONSENTS_ROUTE,
    account.hasPaymentsPage && PAYMENTS_ROUTE,
    account.hasLoansPage && LOANS_ROUTE,
    account.hasObligationsPage && OBLIGATIONS_ROUTE,
    REVIEW_ROUTE,
  ].filter(Boolean);

export const EDITABLE_MERCHANT_DROPDOWN = account => ({
  label: '',
  icon: <FontAwesomeIcon icon={['fal', 'user-tag']} size="lg" />,
  submenu: EDITABLE_MERCHANT_ROUTES(account).filter(route => !!route.component), // TODO: remove filter once Overview is built
  showOnSidebar: true,
});

export const READ_ONLY_DROPDOWN = user => ({
  label: user.accountName,
  icon: <FontAwesomeIcon icon={['fal', 'user-tag']} size="lg" />,
  submenu: [REVIEW_ROUTE], // TODO: remove filter once Overview is built
  showOnSidebar: true,
});

export const INSURANCE_DROPDOWN = user => ({
  label: user.accountName,
  icon: <FontAwesomeIcon icon={['fal', 'user-tag']} size="lg" />,
  // submenu: [PEOPLE_ROUTE], // TODO: remove filter once Overview is built
  showOnSidebar: true,
  submenu: [PEOPLE_ROUTE, BUSINESS_ROUTE],
});
